"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedirectToBilling = exports.indexOfPeriod = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importDefault(require("react"));
var legacy_queries_1 = require("../../../../../shared/api/legacy-queries");
var core_1 = require("../../../../../shared/core");
var components_1 = require("../../../../../shared/core/components");
var Error_1 = require("../../../components/Error");
var RedirectToPeriod = function (_a) {
    var periods = _a.periods, year = _a.year, month = _a.month, route = _a.route;
    var index = (periods && indexOfPeriod(year, month, periods)) || -1;
    var Redirect = (0, components_1.useComponents)().Redirect;
    if (index === -1) {
        return react_1.default.createElement(components_1.NotFoundSection, null);
    }
    return react_1.default.createElement(Redirect, { to: "".concat(route, "/").concat(index) });
};
var Loading = function () {
    return react_1.default.createElement("div", { "data-testid": "redirect-to-billing-loading" });
};
var BillingError = function (_a) {
    var _b = _a.isFetching, isFetching = _b === void 0 ? false : _b;
    return isFetching ? react_1.default.createElement(Loading, null) : react_1.default.createElement(Error_1.Error, null);
};
var RedirectToBilling = function (_a) {
    var year = _a.year, month = _a.month;
    var accountId = (0, ui_tools_1.useAccountContext)().accountId;
    if (!accountId) {
        return null;
    }
    return (react_1.default.createElement(RedirectToBillingMain, { accountId: accountId, year: year, month: month }));
};
exports.RedirectToBilling = RedirectToBilling;
function RedirectToBillingMain(_a) {
    var accountId = _a.accountId, year = _a.year, month = _a.month;
    var billablePeriodEndDatesQueryResult = (0, legacy_queries_1.useBillablePeriodEndDatesLegacyQuery)(accountId);
    return (react_1.default.createElement(ui_tools_1.QueryResultRenderer, { queryResults: [billablePeriodEndDatesQueryResult], forwardProps: { year: year, month: month }, NoData: Loading, Error: BillingError, Data: RedirectToBillingData }));
}
function RedirectToBillingData(_a) {
    var _b = __read(_a.data, 1), periods = _b[0], _c = _a.props, year = _c.year, month = _c.month;
    var billingDetails = (0, core_1.useLinks)().billingDetails;
    return (react_1.default.createElement(RedirectToPeriod, { periods: periods, year: year, month: month, route: billingDetails() }));
}
function indexOfPeriod(year, month, _a) {
    var billablePeriods = _a.billablePeriods;
    var clonedBillablePeriods = __spreadArray([], __read(billablePeriods), false);
    return clonedBillablePeriods
        .reverse()
        .map(function (_a) {
        var end = _a.end;
        return new Date(end);
    })
        .findIndex(function (endDate) {
        return endDate.getFullYear() === year && endDate.getMonth() === month - 1;
    });
}
exports.indexOfPeriod = indexOfPeriod;
